import Card from 'components/Card';
import styles from './ActivateAccount.module.css'
import { Logo } from 'assets';
import { CustomTextField, Button, Checkbox, Modal } from 'components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { IActivateAccount } from 'types/userTypes';
import { apiGetSettings, apiResetPassword } from 'services';
import { useEffect, useState } from 'react';
import mammoth from 'mammoth';
import { env } from 'env';

const ResetPassword = () => {
    const { handleSubmit, control, formState: { errors }, clearErrors, setError } = useForm<IActivateAccount>();
    const [message, setMessage] = useState('')
    const [checked, setChecked] = useState<boolean>(false);
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [htmlContent, setHtmlContent] = useState("");

    const location = useLocation();
    const navigate = useNavigate()
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('token');

    const fetchSettings = async () => {
        try {
          const response = await apiGetSettings();
          const settingsArray = response.data;
    
          const termsSetting = settingsArray.find((setting: any) => setting.attributes.settingName === "termsFile");
    
    
          if (termsSetting && termsSetting.attributes.termsFile?.data?.attributes?.url) {
            const fileUrl = `${env.BASE_URL}${termsSetting.attributes.termsFile.data.attributes.url}`;
    
            const fileResponse = await fetch(fileUrl);
            if (!fileResponse.ok) {
              throw new Error('Network response was not ok');
            }
            const arrayBuffer = await fileResponse.arrayBuffer();
            const result = await mammoth.convertToHtml({ arrayBuffer });
            setHtmlContent(result.value);
          }
        } catch (error) {
          console.error("Error fetching settings:", error);
        }
      };
    
      useEffect(() => {
        fetchSettings();
      }, []);

    const onSubmit: SubmitHandler<IActivateAccount> = (data) => {
        if (!checked) {
            setError("termsAccepted", { message: "יש לאשר את תנאי השימוש" });
            return;
        }

        const { password, passwordConfirmation } = data;

        apiResetPassword({ code, password, passwordConfirmation })
            .then(() => {
                navigate('/login')
            }).catch(err => {
                setMessage('שגיאה, אנא נסה מאוחר יותר')
            });
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked;
        setChecked(isChecked);

        if (isChecked) {
            clearErrors("termsAccepted");
        }
    };

    return (
        <div className={styles.container}>
            <Card>
                <Logo />
                <p className={styles.title}>אנא בחר סיסמא להתחברות</p>
                <p className={styles.label}>יש לבחור סיסמה הכוללת 6 תווים לפחות</p>
                <form style={{ width: '60%' }} onSubmit={handleSubmit(onSubmit)}>
                    <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <CustomTextField
                            name="password"
                            fullWidth
                            type="password"
                            control={control}
                            rules={{ required: true }}
                        />
                        <CustomTextField
                            name="passwordConfirmation"
                            fullWidth
                            type="password"
                            control={control}
                            rules={{ required: true }}
                        />
                        <Box display="flex" flexDirection="column" alignItems="center">
                            <Box display="flex" alignItems="center" justifyContent="center">
                                <Checkbox
                                    checked={checked}
                                    onChange={handleChange}
                                    label={
                                        <span className={styles.termsLabel}>
                                            אישור
                                            <button onClick={(e) => {
                                                e.preventDefault();
                                                setIsVisible(true);
                                            }}>תנאי שימוש</button>
                                        </span>}
                                />
                            </Box>
                            <Box mt={2} width="100%">
                                <Button type="submit" text="להתחברות" />
                            </Box>
                        </Box>
                    </Box>
                </form>
                {errors.termsAccepted && (
                    <p className={styles.error}>
                        {errors.termsAccepted.message}
                    </p>
                )}
                <p className='mt-5 text-danger'>{message}</p>
            </Card>
            {isVisible &&
                <Modal
                    showBackground={false}
                    handleClose={() => setIsVisible(false)}
                    handleSend={() => {
                        setIsVisible(false);
                        setChecked(true)
                    }} data={htmlContent} />}
        </div>
    )

}


export default ResetPassword;
